export default __webpack_public_path__ + "static/media/1260_1276_flexifanér.99ce915b.JPG";